<template>
    <div class="akmnull" :style="{width: cwidth + 'px', height: cwidth + 'px'}">
        <span></span>
    </div>
</template>

<script>
/* eslint-disable */
  export default {
    props: ['cwidth'],
    name: "akmnull"
  }
</script>

<style lang="less">
    .akmnull {
        /*width: 350px;*/
        /*height: 450px;*/
        /*background-color: #FFFFFF;*/
        border-radius: 5px;
        padding: 0 10px;
    }
</style>